import {Service} from './';

export class ApplicationConfigurationService extends Service {

  static entity: string = 'abp/application-configuration';

  static get(): Promise<any> {
    return this.axios.get(`${this.entity}`).then(res => res.data);
  }

}
